import {timelineContainer} from "./timelineContainer";

export class Sprite extends timelineContainer(PIXI.Sprite) {

    constructor(texture?: string | PIXI.Texture, anchor?: { x: number, y: number } | number) {
        super(typeof texture === "object" ? texture :
            texture ? PIXI.utils.TextureCache[texture.replace(/\.\w+$/, "")] :
                undefined);
        if (typeof anchor === "number") {
            this.anchor.set(anchor);
        } else if (anchor) {
            this.anchor.set(anchor.x, anchor.y);
        }
    }

    public setLayoutTexture(name: string, anchorX: number, anchorY: number): void {
        const texture = PIXI.utils.TextureCache[name.replace(/\.\w+$/, "")];
        if (texture) {
            this.texture = texture;
            this.anchor.x = anchorX;
            this.anchor.y = anchorY;
        }
    }
}
